import { Component, Input, OnInit } from '@angular/core';
import { MerchantNotificationRequest } from 'src/app/models/placetopay/merchant-notification-request';

@Component({
  selector: 'app-status-payment',
  templateUrl: './status-payment.component.html',
  styleUrls: ['./status-payment.component.css']
})
export class StatusPaymentComponent {
  @Input() public request : MerchantNotificationRequest;
  
  showMessage: boolean = false;

  toggleMessage(): void {
    this.showMessage = !this.showMessage;
  }
}
